export default{
    state:{       
        // establecimiento:{
        //     nombrecomercial:'MADERAS Y DISEÑOS ALARCON',
        //     codigo:'1',
        //     propietario:'RONY ALFONSO DUQUE ALARCÓN',
        //     nit:'30192633',
        //     direccion:'MANZANA 20 LOTE 18 VILLA DEL QUETZAL CIUDAD QUETZAL, SAN JUAN SACATEPÉQUEZ, GUATEMALA',
        //     codigopostal:'01059',
        //     municipio:'SAN JUAN SACATEPÉQUEZ',
        //     departamento:'GUATEMALA',
        //     codregimen:'GEN' //COMERCIO
        // },
        establecimiento:{
            nombrecomercial:'INMOBILIARIA LA COLINA',
            codigo:'4',
            propietario:'LESBIA MARLENY, RODRIGUEZ RODRIGUEZ',
            nit:'39174336',
            direccion:'3RA CALLE ENTRE 2DA Y 3RA AVENIDA ZONA 1 BARRIO LA ESPERANZA JALAPA JALAPA',
            codigopostal:'21001',
            municipio:'JALAPA',
            departamento:'JALAPA',
            codregimen:'GEN'
        }
        
    },
    getters:{
        getEstablecimiento(state){
            return state.establecimiento
        }
    }
}